import { checkGetSubscription, checkUserProfile, readOnlyControl, userPermissionControl } from 'Utility/globalMethods'
import { defineMessages } from 'react-intl'
import { messages as dashboardMessageDefinitions } from 'Route/Dashboard/modules/languageModule'

export const dashboardMessages = dashboardMessageDefinitions

export const navigationMessages = defineMessages({
  menu: { id: 't.app.header.menu.menuTitle', defaultMessage: 'Menu' },
  home: { id: 't.app.header.home', defaultMessage: 'Home' },
  customers: { id: 't.app.header.customers', defaultMessage: 'Customers' },
  open: { id: 't.app.accessibility.project.btn.open.ariaLabel', defaultMessage: 'Open' },
  close: { id: 't.app.accessibility.project.btn.close.ariaLabel', defaultMessage: 'Close' },
  payments: { id: 't.app.header.payments.title', defaultMessage: 'Payments' },
  ordersManagement: { id: 't.app.header.ordersManagement', defaultMessage: 'Orders' },
  operationsManagement: { id: 't.app.header.operationsManagement.title', defaultMessage: 'Operations' },
  subscriptionManagement: { id: 't.app.subscriptionManagement.title', defaultMessage: 'Subscriptions' },
  payByLink: { id: 't.app.header.services.payByLink', defaultMessage: 'Pay-by-Link Plus' },
  quickActionPayByLink: { id: 't.app.header.quickActions.payByLink', defaultMessage: 'New Pay-by-link' },
  quickActionPayToCard: { id: 't.app.header.quickActions.payToCard', defaultMessage: 'New Pay-to-card' },
  moto: { id: 't.app.header.services.moto', defaultMessage: 'MOTO Payment' },
  cardCheck: { id: 't.app.services.cardCheck.title', defaultMessage: 'Card Check' },
  configuration: { id: 't.app.header.configuration', defaultMessage: 'Configuration' },
  manageTerminals: { id: 't.app.header.manageTerminals', defaultMessage: 'Terminals' },
  stores: { id: 't.app.header.stores', defaultMessage: 'Stores' },
  users: { id: 't.app.header.users', defaultMessage: 'Users' },
  bookingManagement: { id: 't.app.header.bookingManagement', defaultMessage: 'Booking Management' },
  newBooking: { id: 't.app.header.quickActions.newBooking', defaultMessage: 'New Booking' },
  quickActions: { id: 't.app.header.quickActions', defaultMessage: 'Quick actions' },
  services: { id: 't.app.header.services', defaultMessage: 'Services' }
})

export const getLabels = (intl, messageDefinitions) =>
  Object.entries(messageDefinitions).reduce((labels, [key, message]) => {
    labels[key] = intl.formatMessage(message)
    return labels
  }, {})


const hasPermission = (key, context) => userPermissionControl(key, context.userPermissions)
const hasSubscription = (key, context, checkStatus = false) => checkGetSubscription(context.getSubscriptionArray, key, undefined, checkStatus)

export const navigationMap = [
  {
    id: 'customers',
    group: 'customers',
    isVisible: () => false
  },
  {
    id: 'payByLinkQuickAction',
    group: 'quickActions',
    isVisible: (context) => hasPermission('services.paybylink', context) && hasSubscription('PAYBYLINK', context)
  },
  {
    id: 'bookingQuickAction',
    group: 'quickActions',
    isVisible: (context) =>
      hasPermission('booking.management', context) &&
      !readOnlyControl('booking.management', context.userPermissions) &&
      hasSubscription('DISPUTELESS', context)
  },
  {
    id: 'motoQuickAction',
    group: 'quickActions',
    isVisible: (context) => hasPermission('services.moto', context) && checkUserProfile(context.userProfile, 'MOTO')
  },
  {
    id: 'cardCheckQuickAction',
    group: 'quickActions',
    isVisible: (context) => hasPermission('settings.terminals.cardCheck', context) && checkUserProfile(context.userProfile, 'MOTO')
  },
  {
    id: 'payToCardQuickAction',
    group: 'quickActions',
    isVisible: (context) =>
      hasPermission('settings.terminals.vas.payToCard', context) && hasSubscription('PAYTOCARD', context, true)
  },
  {
    id: 'orders',
    group: 'payments',
    isVisible: (context) => hasPermission('orders', context)
  },
  {
    id: 'operations',
    group: 'payments',
    isVisible: (context) => hasPermission('operationsManagement', context)
  },
  {
    id: 'subscriptions',
    group: 'payments',
    isVisible: (context) =>
      hasPermission('recurring', context) && hasSubscription('RECURRENCECONTRACTTYPE', context, true)
  },
  {
    id: 'storeManagement',
    group: 'configuration',
    isVisible: (context) => context.type?.includes('admin')
  },
  {
    id: 'terminalsManagement',
    group: 'configuration',
    isVisible: (context) => hasPermission('settings.terminals', context)
  },
  {
    id: 'usersManagement',
    group: 'configuration',
    isVisible: (context) => hasPermission('settings.users', context)
  },
  {
    id: 'payByLink',
    group: 'services',
    isVisible: (context) => hasPermission('services.paybylink', context) && hasSubscription('PAYBYLINK', context)
  },
  {
    id: 'bookingManagement',
    group: 'services',
    isVisible: (context) => hasPermission('booking.management', context) && hasSubscription('DISPUTELESS', context)
  }
]

export const isNavigationItemVisible = (id, context) =>
  navigationMap.find((item) => item.id === id)?.isVisible(context) || false

export const getNavigationItems = (context) => navigationMap.filter(({ id }) => isNavigationItemVisible(id, context))
